const BENEFITS_COUNT = 4;

export const BENEFITS_KEYS = new Array(BENEFITS_COUNT)
    .fill(null)
    .map((_, index) => `v17.pro_section.benefits.${index}`);
